/**
 * Helper to create an Action Log entry in the backend.
 * This function is intentionally not awaiting the promise so the caller isn't blocked. (fire-and-forget)
 */
export async function logAction(payload) {
  const store = (await import('../store')).default
  const { API } = await import('./index')

  const state = store.getState()

  const type = state.general.widgetMode === 'search' ? 'search' : 'chat'

  const body = {
    name: payload.name,
    type,
    ...(payload.url && { url: payload.url }),
    ...(payload.linkLabel && { linkLabel: payload.linkLabel }),
    chatSlug: state.maya?.slug,
    searchSlug: state.maya?.searchSlug,
    token: state.maya?.token,
  }

  // Fire-and-forget – we don't await the promise so the caller isn't blocked.
  API.postRequest('/helpers/action-logs', body)
    .then(res => {})
    // Silently ignore failures
    .catch(() => {})
}
